// Call plugin.
import * as sagas from './sagas'
import anonymousAPI from '../interfaceNew/api/callMe'

// Other plugins
import callsNewLink from '../link'

// Helpers.
import { autoRestart } from '../../common/utils'

// Libraries.
import { values } from 'lodash/fp'
import { fork } from 'redux-saga/effects'

export default function newCallMePlugin (options = {}) {
  /*
   * The usual configuration validation is done as part of the Link plugin.
   */

  const linkCallPlugin = callsNewLink(options)

  // If the Link Call factory returned undefined, do the same here.
  //    This happens when the platform does not support WebRTC.
  if (typeof linkCallPlugin === 'undefined') {
    return
  }

  return {
    name: linkCallPlugin.name,
    api: anonymousAPI(linkCallPlugin.api),
    reducer: linkCallPlugin.reducer,
    init: anonymousInit(linkCallPlugin.init),
    capabilities: ['callMe']
  }
}

/**
 * Returns an init function which also calls another plugin's init function.
 * @method anonymousInit
 * @param {function} otherInit The other plugin's init function.
 */
function anonymousInit (otherInit) {
  return function * init ({ webRTC }) {
    // Run the other plugin's init
    yield fork(otherInit, { webRTC })

    // Wrap the newCallMe sagas in a function that provides them with the webRTC stack.
    const deps = { webRTC, browserDetails: webRTC.getBrowserDetails }
    const wrappedSagas = values(sagas).map(saga => {
      return autoRestart(() => saga(deps))
    })

    // Run all of the sagas.
    for (const saga of wrappedSagas) {
      yield fork(saga)
    }
  }
}
